// Display preferences are optional; authentication must work without Web Storage.
export function readDisplayUser() {
  try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
}
export function removeLegacyToken() {
  try { localStorage.removeItem("token"); } catch {}
}
export function saveDisplayUser(user) {
  removeLegacyToken();
  try { localStorage.setItem("user", JSON.stringify(user)); } catch {}
}
export function clearDisplayUser() {
  removeLegacyToken();
  try { localStorage.removeItem("user"); } catch {}
}
export function takePendingInvitation() {
  try {
    const invitation = localStorage.getItem("pendingInvitation");
    localStorage.removeItem("pendingInvitation");
    return invitation;
  } catch { return null; }
}
